/**
 * Formatters for currency, numbers, and percentages
 */

/**
 * Format currency (RON)
 */
export const formatCurrency = (value, currency = 'RON', locale = 'ro-RO') => {
  if (value === null || value === undefined || isNaN(value)) {
    return '-';
  }
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

/**
 * Format currency with decimals
 */
export const formatCurrencyPrecise = (value, currency = 'RON', locale = 'ro-RO') => {
  if (value === null || value === undefined || isNaN(value)) {
    return '-';
  }
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * Format number with thousand separators
 */
export const formatNumber = (value, locale = 'ro-RO') => {
  if (value === null || value === undefined || isNaN(value)) {
    return '-';
  }
  
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

/**
 * Format percentage
 */
export const formatPercentage = (value, decimals = 1, locale = 'ro-RO') => {
  if (value === null || value === undefined || isNaN(value)) {
    return '-';
  }
  
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value / 100);
};

/**
 * Format large numbers (shortened)
 */
export const formatCompactNumber = (value, locale = 'ro-RO') => {
  if (value === null || value === undefined || isNaN(value)) {
    return '-';
  }
  
  return new Intl.NumberFormat(locale, {
    notation: 'compact',
    compactDisplay: 'short',
  }).format(value);
};

/**
 * Parse currency string to number
 */
export const parseCurrency = (str) => {
  if (!str) return 0;
  // Remove currency symbols, spaces, and thousand separators
  const cleaned = str.toString().replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
  return parseFloat(cleaned) || 0;
};

/**
 * Format for chart tooltip
 */
export const formatChartValue = (value) => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(0)}K`;
  }
  return value.toFixed(0);
};

/**
 * Export data to CSV
 */
export const exportToCSV = (data, filename, headers, language = 'ro') => {
  const csvHeaders = headers.map(h => h.label).join(',');
  const csvRows = data.map(row => 
    headers.map(h => {
      const value = row[h.key];
      // Escape commas and quotes
      if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    }).join(',')
  );
  
  const csvContent = [csvHeaders, ...csvRows].join('\n');
  const BOM = '\uFEFF'; // UTF-8 BOM for proper Excel encoding
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
  
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
};
